
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import Testimonials from '@devsisters/ui-careers/lib/Testimonials';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"testimonials"}}>{`Testimonials`}</MDXTag>
<MDXTag name="p" components={components}>{`사이트 메인의 추천사 영역에 사용되는 컴포넌트입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import Testimonials from '@devsisters/ui-careers/lib/Testimonials';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const testimonials = [\n    {\n      quote:\n        \'이상의 설레는 우는 사막이다. 피고, 동산에는 따뜻한 약동하다. 튼튼하며, 두손을 꾸며 없는 속잎나고, 피다. 커다란 싸인 청춘의 보는 구할 심장은 사막이다.\',\n      who: \'말한사람\',\n    },\n    {\n      quote:\n        \'그들에게 것은 간에 위하여 것이다. 이상이 목숨이 커다란 이상의 간에 같지 것이다.\',\n      who: \'용감한 쿠키\',\n    },\n    {\n      quote:\n        \'위하여 소리다.이것은 있을 품으며, 약동하다. 사람은 속에 인생을 이것이다. 싸인 그들을 공자는 보라. 것은 실로 목숨을 때에, 품에 사막이다.\',\n      who: \'명랑한 쿠키\',\n    },\n  ]\n  return (\n    <>\n      <h1>pc</h1>\n      <Testimonials\n        type=\"pc\"\n        style={{ height: \'300px\' }}\n        testimonials={testimonials}\n      />\n      <h1>mobile</h1>\n      <Testimonials\n        type=\"mobile\"\n        style={{ height: \'300px\' }}\n        testimonials={testimonials}\n      />\n      <h1>자동재생 off</h1>\n      <Testimonials\n        autoplay={false}\n        style={{ height: \'300px\' }}\n        testimonials={testimonials}\n      />\n      <h1>빠르게 자동재생</h1>\n      <Testimonials\n        autoplay={1000}\n        style={{ height: \'300px\' }}\n        testimonials={testimonials}\n      />\n    </>\n  )\n}'} __scope={{props: this ? this.props : props,Testimonials}}>
  {() => {
    const testimonials = [
      {
        quote: '이상의 설레는 우는 사막이다. 피고, 동산에는 따뜻한 약동하다. 튼튼하며, 두손을 꾸며 없는 속잎나고, 피다. 커다란 싸인 청춘의 보는 구할 심장은 사막이다.',
        who: '말한사람',
      },
      {
        quote: '그들에게 것은 간에 위하여 것이다. 이상이 목숨이 커다란 이상의 간에 같지 것이다.',
        who: '용감한 쿠키',
      },
      {
        quote: '위하여 소리다.이것은 있을 품으며, 약동하다. 사람은 속에 인생을 이것이다. 싸인 그들을 공자는 보라. 것은 실로 목숨을 때에, 품에 사막이다.',
        who: '명랑한 쿠키',
      },
    ];
    return <>
      <h1>pc</h1>
      <Testimonials type='pc' style={{ height: '300px' }} testimonials={testimonials}/>
      <h1>mobile</h1>
      <Testimonials type='mobile' style={{ height: '300px' }} testimonials={testimonials}/>
      <h1>자동재생 off</h1>
      <Testimonials autoplay={false} style={{ height: '300px' }} testimonials={testimonials}/>
      <h1>빠르게 자동재생</h1>
      <Testimonials autoplay={1000} style={{ height: '300px' }} testimonials={testimonials}/>
    </>;
  }}
</Playground>
           </MDXTag>
  }
}
  